function times(n: number, func: (i: any) => any = i => i) {
  return Array.from({ length: n }).map((_, i) => func(i));
}

export default times;
